import React, { useEffect, useState, useRef } from "react";
import { sectionHeadingData } from "../../content/course-detail-page";

interface Props {
  title: string;
  paragraph?: string;
  className?: string;
}

const SectionHeading: React.FC<Props> = ({ title, paragraph, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const paragraphRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    if (paragraphRef.current) {
      const checkContentOverflow = () => {
        const lineHeight = parseFloat(
          getComputedStyle(paragraphRef.current!).lineHeight,
        );
        const maxHeight = lineHeight * 3;

        if (paragraphRef.current!.scrollHeight > maxHeight) {
          setIsOverflowing(true);
        }
      };
      checkContentOverflow();
    }
  }, [paragraph]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="my-12">
      <h2
        className={`mb-3 py-[6px] md:text-xl border-l-[6px] pl-3 border-secondary text-lg font-bold leading-tight md:leading-[32px] ${className}`}
      >
        {title}
      </h2>

      {paragraph && (
        <div>
          <p
            ref={paragraphRef}
            className={`text-sidebarText text-justify sm:text-sm  overflow-hidden ${
              !isExpanded ? "line-clamp-3" : ""
            }`}
          >
            {paragraph}
          </p>
          {isOverflowing && (
            <button
              onClick={handleToggle}
              className="mt-2 text-primary alert sm:text-sm"
              id="toggle-button"
            >
              {isExpanded
                ? sectionHeadingData.readLess
                : sectionHeadingData.readMore}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionHeading;
